// extracted by mini-css-extract-plugin
export default {"labelWrapper":"DraggablePeriod_labelWrapper__kYHWX","label":"DraggablePeriod_label__rDEfK","talkIcon":"DraggablePeriod_talkIcon__We5DK"};